import _Vue, { PluginObject } from 'vue';
import { Store } from 'vuex';
import { AuthPort, AuthPortFactory } from '@/modules/auth';
import { AuthModuleAdapter } from '@/store/auth/AuthModuleAdapter';

interface Ports {
    auth: AuthPort;
}

// register vue plugin
const portsPlugin: PluginObject<any> = {
    install(vue: typeof _Vue, store: Store<any>): void {
        // Instantiate ports
        const ports: Ports = {
            auth: AuthPortFactory.createAuthPort({
                appId: process.env.VUE_APP_APPID || '',
                loginServiceUrl: process.env.VUE_APP_LOGIN_URL || '',
                store: new AuthModuleAdapter(store),
            }),
        };

        vue.prototype.$ports = ports;
        vue.ports = ports;
    },
};

export default portsPlugin;

// add type definitions for typescript compiler
declare module 'vue/types/vue' {
    interface Vue {
        $ports: Ports;
    }

    interface VueConstructor {
        ports: Ports;
    }
}
